import { Component, OnInit, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { DateService } from 'app/date/date.service';
import { UtilService } from 'app/hrms/shared/util.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from 'app/sessions/session.service';
import * as firebase from "firebase/app";
import { UserService } from 'app/users/shared/user.service';
@Component({
  selector: 'app-attendance-tab-me',
  templateUrl: './attendance-tab-me.component.html',
  styleUrls: ['./attendance-tab-me.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AttendanceTabMeComponent implements OnInit {
  date:Date;
  gridView:GridDataResult;
  public skip1 = 0;
  public pageSize = 10;
  public skip2 = 0;
  attendanceList:any;
  attendanceListSearch:any;
  searchForm:FormGroup;
  attendanceForm:FormGroup;
  isSearch:boolean = false;
  @ViewChild("AttendanceModal") AttendanceModal;
  @Input("holidays") holidays;
  employeeLeaveList:any;
  toEditDataItem:any;
  constructor(private hrmsService:HRMSService, private dateService:DateService, private util:UtilService, private ss:SessionService, private userService:UserService) { }

  async ngOnInit() {
    this.initializeForm();
    await this.getMyLeaves();
    //this.getMyAttendanceList();
    setTimeout(() => {
      this.getMyAttendanceList();
    }, 300); 
  }
  initializeForm()
  {
    this.searchForm = new FormGroup({
      from: new FormControl(''),
      to: new FormControl('')
    });
    this.searchForm.reset();

    this.attendanceForm = new FormGroup({
      date: new FormControl('',Validators.required),
      clockIn: new FormControl({hour: 0, minute: 0, second: 0},Validators.required),
      clockOut: new FormControl({hour: 0, minute: 0, second: 0},Validators.required)
    });
    //this.attendanceForm.reset();
  }
  getMyAttendanceList()
  {
    /* var date1 = this.util.getDateSearchForm(new Date());
    var date2 = this.util.getDateSearchForm(new Date()); */
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    var lastDay = new Date(y, m + 1, 1);
    //console.log("timestamp",new Date(firstDay).getTime(),new Date(lastDay).getTime(),firstDay,lastDay);
    this.hrmsService.getAttendance(this.ss.getEmployeeId,new Date(firstDay).getTime(),new Date(lastDay).getTime()).snapshotChanges().subscribe((data)=>{
      this.attendanceList = [];
      data.forEach(date=>{
          var list = [];
          var attendanceData = date.payload.child("logs").val();
          var hours= 0;
          for(let i in attendanceData)
          {
              if(attendanceData[i].clockOut!= null)
              {
                var date1 = new Date(date.key+" "+attendanceData[i].clockIn);
                var date2 = new Date(date.key+" "+attendanceData[i].clockOut);
                hours = hours + this.util.getDiff(date1,date2);
                attendanceData[i].key = i;
              }
              list.push(attendanceData[i]);
          }
          this.constructObject(date,list,hours);
    });
    this.loadItem();
  });
  } 
  constructObject(date,list,hours)
  {
    var leaveExists = false;
    if(this.employeeLeaveList)
    {
    var userLeaves = this.employeeLeaveList[this.ss.getEmployeeId];
    for(let i in userLeaves)
    {
      if(this.util.checkDatesWithinRange(userLeaves[i].from,userLeaves[i].to,this.dateService.getDate(new Date(date.key))) && !leaveExists)
      {
        leaveExists = true;
      }
    }
    }
    var object = {
      "Date": this.dateService.getFullDate(date.key),
      "InTime": list[0].clockIn?list[0].clockIn:"--",
      "OutTime": list[list.length-1].clockOut?list[list.length-1].clockOut:"--",
      "TotalHours": this.util.msToTime(Number(hours)),
      "dateId": date.key,
      "day":this.dateService.dayNameOfWeek(date.key),
      "holidayName":this.holidays[this.dateService.getDate(new Date(date.key))]?this.holidays[this.dateService.getDate(new Date(date.key))].occasion:"",
      "isOnLeave":leaveExists,
      "Status": date.payload.child("status").val()
    };
  this.attendanceList.push(object);
  }
  loadItem()
  {
    if(this.isSearch)
    {
      this.sortList(this.attendanceListSearch);
      this.gridView = {
        data: this.attendanceListSearch.slice(this.skip1, this.skip1 + this.pageSize),
        total: this.attendanceListSearch.length
      };
    }
    else
    {
      this.sortList(this.attendanceList);
      this.gridView = {
        data: this.attendanceList.slice(this.skip1, this.skip1 + this.pageSize),
        total: this.attendanceList.length
      };
    }
  }
  public pageChange(event: PageChangeEvent): void {
    this.skip1 = event.skip;
    this.loadItem();
  }
  onEdit(dataItem)
  {
    this.toEditDataItem = dataItem;
    this.attendanceForm.get("date").setValue(new Date(dataItem.dateId));
    this.attendanceForm.get("clockIn").setValue(this.util.getTimeIn24HoursFormat(dataItem.InTime));
    this.attendanceForm.get("clockOut").setValue(this.util.getTimeIn24HoursFormat(dataItem.OutTime));
    this.AttendanceModal.show();
  } 
  update()
  {
    if(this.attendanceForm.valid && this.attendanceForm.value.clockIn.hour && this.attendanceForm.value.clockOut.hour)
    {
      var clockIn = {
        clockIn: this.util.getFormattedDate(this.attendanceForm.value.clockIn),
        updatedAt: this.dateService.getTimeandDate().timeStamp
      }
      var clockOut = {
        clockOut: this.util.getFormattedDate(this.attendanceForm.value.clockOut),
        updatedAt: this.dateService.getTimeandDate().timeStamp
      }
      var key  = firebase.database().ref("attendance/data").push().key;
      this.hrmsService.getFirstClockInOut(this.ss.getEmployeeId,this.toEditDataItem.dateId).once("value").then((data)=>{
        data.forEach((element)=>{
          if(element.numChildren()>0)
          {
            this.hrmsService.updateAttendance(this.ss.getEmployeeId,this.toEditDataItem.dateId,element.key,clockIn).then(()=>{
              this.hrmsService.changeAttendanceStatus(this.ss.getEmployeeId,this.toEditDataItem.dateId,"pending").then(()=>{
                this.hrmsService.sendAttendanceNotif(this.ss.getEmployeeId,this.toEditDataItem.dateId,"pending","unread");
              });
            });
          }
          else
          {
            
            this.hrmsService.addAttendance(this.ss.getEmployeeId,this.toEditDataItem.dateId,clockIn,key).then(()=>{
              this.hrmsService.sendAttendanceNotif(this.ss.getEmployeeId,this.toEditDataItem.dateId,"pending","unread");
            });
          }
        });
      });
      this.hrmsService.getLastClockInOut(this.ss.getEmployeeId,this.toEditDataItem.dateId).once("value").then((data)=>{
        data.forEach((element)=>{
          if(element.numChildren()>0)
          {
            this.hrmsService.updateAttendance(this.ss.getEmployeeId,this.toEditDataItem.dateId,element.key,clockOut).then(()=>{
              this.hrmsService.changeAttendanceStatus(this.ss.getEmployeeId,this.toEditDataItem.dateId,"pending").then(()=>{
                this.hrmsService.sendAttendanceNotif(this.ss.getEmployeeId,this.toEditDataItem.dateId,"pending","unread");
              });
            });
          }
          else
          {
            this.hrmsService.addAttendance(this.ss.getEmployeeId,this.toEditDataItem.dateId,clockOut,key).then(()=>{
              this.hrmsService.sendAttendanceNotif(this.ss.getEmployeeId,this.toEditDataItem.dateId,"pending","unread");
            });
          }
        });
      });
      this.AttendanceModal.hide();
    }
  }
  public onSubmitSearch()
  {
  this.isSearch = true;
  var dateFrom = this.dateService.getDate(this.searchForm.value.from);
  var dateTo = this.dateService.getDate(this.searchForm.value.to);
  this.hrmsService.getAttendance(this.ss.getEmployeeId,new Date(dateFrom).getTime(),new Date(dateTo).getTime()).snapshotChanges().subscribe((data)=>{
    this.attendanceListSearch = [];
    data.forEach(attendance=>{
      var dateToCheck  = this.dateService.getDate(new Date(attendance.key));
      /* if(this.util.checkDatesWithinRange(dateFrom,dateTo,dateToCheck))
      { */
        var list = [];
        var hours=0;
        var attendanceData = attendance.payload.child("logs").val();
        
        for(let i in attendanceData)
        {
            if(attendanceData[i].clockOut!= null)
            {
              var date1 = new Date(attendance.key+" "+attendanceData[i].clockIn);
              var date2 = new Date(attendance.key+" "+attendanceData[i].clockOut);
              hours = hours + this.util.getDiff(date1,date2);
              attendanceData[i].key = i;
            }
            list.push(attendanceData[i]);
        }
        var leaveExists = false;
    if(this.employeeLeaveList)
    {
    var userLeaves = this.employeeLeaveList[this.ss.getEmployeeId];
    for(let i in userLeaves)
    {
      if(this.util.checkDatesWithinRange(userLeaves[i].from,userLeaves[i].to,this.dateService.getDate(new Date(attendance.key))) && !leaveExists)
      {
        leaveExists = true;
      }
    }
    }
        var object = {
          "Date": this.dateService.getFullDate(attendance.key),
          "InTime": list[0]?list[0].clockIn:"--",
          "OutTime": list[list.length-1]?list[list.length-1].clockOut:"--",
          "TotalHours": this.util.msToTime(Number(hours)),
          "id": attendance.key,
          "dateId": attendance.key,
          "day":this.dateService.dayNameOfWeek(attendance.key),
          "holidayName":this.holidays[this.dateService.getDate(new Date(attendance.key))]?this.holidays[this.dateService.getDate(new Date(attendance.key))].occasion:"",
          "isOnLeave":leaveExists,
          "Status": attendance.payload.child("status").val()
        };
      this.attendanceListSearch.push(object);
    //}
  });
  this.loadItem();
});
}
clearSearch()
{
  this.isSearch = false;
  this.searchForm.reset();
  this.loadItem();
}
sortList(data)
{
  data.sort(function(a,b){
    var c = new Date(a.Date);
    var d = new Date(b.Date);
    return d.getTime() - c.getTime();  
    });
}
getMyLeaves()
{
  this.hrmsService.getEmployeeLeavesById(this.ss.getUserId).on("value",(leaves)=>{
    this.employeeLeaveList = [];
    this.employeeLeaveList[this.ss.getEmployeeId] = leaves.val();
    });
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/attendance/attendance-tab-me/attendance-tab-me.component.ts